<script lang="ts" setup>
import { Editor, EditorContent } from '@tiptap/vue-3'

defineProps({
  editor: Editor,
})
</script>
<template>
  <div v-if="editor" class="editor-container my-2 md:my-4">
    <EditorContent
      :editor="editor"
      class="text-base leading-6 text-communities-font-primary"
    />
  </div>
</template>
<style>
/* Placeholder (at the top) */
.ProseMirror p.is-editor-empty:first-child::before {
  content: attr(data-placeholder);
  float: left;
  color: #adb5bd;
  pointer-events: none;
  height: 0;
}
.ProseMirror-focused {
  outline: none;
}
.ProseMirror {
  font-size: 18px !important;
}
</style>
<style scoped>
.editor-container {
  position: relative;
  min-height: 144px;
  border-radius: 0.5rem;
  border: var(--border-style) #d0d5dd;
  padding: 4px 8px;
  max-height: 28vh;
  overflow-y: auto;
}
.editor-container::-webkit-scrollbar {
  display: none;
}

.ProseMirror p {
  display: block;
  font-size: 18px;
  margin-block-start: 0em;
  margin-block-end: 0em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  margin: 0px;
}
@media (max-width: 930px) {
  .editor-container {
    border: none !important;
    position: relative;
    min-height: 144px;
    padding: 4px 8px;
    max-height: 50vh;
    overflow-y: auto;
  }
}
</style>
